module.exports = __webpack_public_path__ + "public/images/slider/potapov.c5d630a761df5a86045ba420c3b1360c.png";